const VantivErrorCodes = {
  THREAT_METRIX_AUTO_DECLINE_FAIL: 5050,
  VANTIV_INVALID_CVV: 5051,
  VANTIV_INVALID_BILLING_ADDRESS: 5052,
  VANTIV_INVALID_BILLING_ZIP: 5053,
};

const InternalErrorCodes = {
  INTERNAL_UNKNOWN_ERROR: 5000,
  INTERNAL_DB_ERROR: 5001,
  INTERNAL_BOOM_ERROR: 5002,
};

const UnprocessableEntityCodes = {
  KYCK_GLOBAL_ONBOARDING_ERROR: 4200,
  KYCK_GLOBAL_ONBOARDING_PERSIST_ERROR: 4201,
  KYCK_GLOBAL_ONBOARDING_ALREADY_ONBOARDED_ERROR: 4202,
};

const BadRequestErrorCodes = {
  SCHEMA_VALIDATION_ERROR: 4000,
};

// Error codes for custom domuso error messages.
const DomusoCustomErrorCodes = {
  // Address validation error messages shown based on number of failed attempts.
  AVS_FAILED_LOW_ERROR: 10000,
  AVS_FAILED_MED_ERROR: 10001,
  AVS_FAILED_HIGH_ERROR: 10002,
  CUSTOM_THREAT_METRIX_ERROR: 10003,
  CUSTOM_GENERAL_ERROR: 10004,
  CUSTOM_GENERAL_FREQUENT_PAYMENT_ERROR: 10005,
};

const ExperianLinkErrorCodes = {
  EXPERIAN_LINK_REQUEST_FAIL: 6000,
  EXPERIAN_LINK_NO_NAME_MATCH: 6001,
};

const ErrorCodes = {
  ...VantivErrorCodes,
  ...InternalErrorCodes,
  ...BadRequestErrorCodes,
  ...UnprocessableEntityCodes,
  ...DomusoCustomErrorCodes,
  ...ExperianLinkErrorCodes,
  VALUES: () =>
    Object.keys(ErrorCodes)
      .filter(key => typeof ErrorCodes[key] !== 'function')
      .map(key => ErrorCodes[key]),
};

module.exports = { ErrorCodes, VantivErrorCodes, InternalErrorCodes, BadRequestErrorCodes, ExperianLinkErrorCodes };
